export default __webpack_public_path__ + "static/platform-ifc-viewer-6d7323fa3287e6a1daeaa981c5dbd18f.png";